import Core from 'core/js/pages/planner/direction-internal-result/index'
import PlannerMap from './_planner-map'
import NewSearchDirectionsForm from './_new-search-directions-form'

export default {
  extends: Core,
  template: Core.template,
  components: {
    ...Core.components,
    PlannerMap,
    NewSearchDirectionsForm
  }
}
